import {
  COMPANY_STORAGE_LOCATION_LIST,
  COMPANY_STORAGE_LOCATION_LIST_SUCCESS,
  COMPANY_STORAGE_LOCATION_LIST_FAILURE,
  COMPANY_STORAGE_LOCATION_DATA,
  COMPANY_STORAGE_LOCATION_DATA_SUCCESS,
  COMPANY_STORAGE_LOCATION_DATA_FAILURE,
  COMPANY_STORAGE_LOCATION_CREATE,
  COMPANY_STORAGE_LOCATION_CREATE_SUCCESS,
  COMPANY_STORAGE_LOCATION_CREATE_FAILURE,
  COMPANY_STORAGE_LOCATION_UPDATE,
  COMPANY_STORAGE_LOCATION_UPDATE_SUCCESS,
  COMPANY_STORAGE_LOCATION_UPDATE_FAILURE,
  COMPANY_STORAGE_LOCATION_DELETE,
  COMPANY_STORAGE_LOCATION_DELETE_SUCCESS,
  COMPANY_STORAGE_LOCATION_DELETE_FAILURE,
} from "./actionType";

export const companyStorageLocationList = () => ({ type: COMPANY_STORAGE_LOCATION_LIST });
export const companyStorageLocationListSuccess = (data) => ({ type: COMPANY_STORAGE_LOCATION_LIST_SUCCESS, payload: data });
export const companyStorageLocationListFailure = (error) => ({ type: COMPANY_STORAGE_LOCATION_LIST_FAILURE, payload: error });

export const companyStorageLocationData = (data) => ({ type: COMPANY_STORAGE_LOCATION_DATA, payload: data });
export const companyStorageLocationDataSuccess = (data) => ({ type: COMPANY_STORAGE_LOCATION_DATA_SUCCESS, payload: data });
export const companyStorageLocationDataFailure = (error) => ({ type: COMPANY_STORAGE_LOCATION_DATA_FAILURE, payload: error });

export const companyStorageLocationCreate = (data) => ({ type: COMPANY_STORAGE_LOCATION_CREATE, payload: data });
export const companyStorageLocationCreateSuccess = (data) => ({ type: COMPANY_STORAGE_LOCATION_CREATE_SUCCESS, payload: data });
export const companyStorageLocationCreateFailure = (error) => ({ type: COMPANY_STORAGE_LOCATION_CREATE_FAILURE, payload: error });

export const companyStorageLocationUpdate = (data) => ({ type: COMPANY_STORAGE_LOCATION_UPDATE, payload: data });
export const companyStorageLocationUpdateSuccess = (data) => ({ type: COMPANY_STORAGE_LOCATION_UPDATE_SUCCESS, payload: data });
export const companyStorageLocationUpdateFailure = (error) => ({ type: COMPANY_STORAGE_LOCATION_UPDATE_FAILURE, payload: error });

export const companyStorageLocationDelete = (data) => ({ type: COMPANY_STORAGE_LOCATION_DELETE, payload: data });
export const companyStorageLocationDeleteSuccess = (data) => ({ type: COMPANY_STORAGE_LOCATION_DELETE_SUCCESS, payload: data });
export const companyStorageLocationDeleteFailure = (error) => ({ type: COMPANY_STORAGE_LOCATION_DELETE_FAILURE, payload: error });
